// src/assets/data/cursos/cripto-blockchain/en/modulo-3-en.js
import banner from "../../../courses/module-2/img3.png";

const modulo3 = {
  courseId: "cripto-blockchain",
  id: "modulo-3",
  title:
    "🧩 MODULE 3: Bitcoin, Ethereum, Solana, Cardano, Polygon and Stellar – The Big Leagues of Crypto",
  estimatedDuration: "1 hour 30 minutes",
  format: "Reading + knowledge check activity",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objectives",
      title: "🎯 Module objective",
      content: [
        "Learn the characteristics, differences, and main uses of six leading blockchains in the crypto world, understanding what each one is used for, how it works, and why it is important not to confuse networks when making transactions.",
      ],
    },
    {
      id: "por-que",
      navLabel: "Why so many?",
      title: "🌍 Why are there so many blockchains?",
      content: [
        {
          type: "paragraph",
          text: "Each blockchain was created with a different purpose: some prioritize speed, others security, financial inclusion, or application development.",
        },
        {
          type: "paragraph",
          text: "That is why it is essential to know which network is best suited for each situation.",
        },
      ],
    },
    {
      id: "bitcoin",
      navLabel: "Bitcoin (BTC)",
      title: "🔹 Bitcoin (BTC): the pioneer and “digital gold”",
      content: [
        {
          type: "paragraph",
          text: "What is it? The first cryptocurrency, created in 2009 to allow payments without banks.",
        },
        {
          type: "paragraph",
          text: "Main use: Store value, like digital gold, and send simple payments.",
        },
        {
          type: "paragraph",
          text: "Extra fact: It is the most secure network, but also one of the slowest and most expensive.",
        },
      ],
    },
    {
      id: "ethereum",
      navLabel: "Ethereum (ETH)",
      title: "🔹 Ethereum (ETH): the foundation of the Web3 world",
      content: [
        {
          type: "paragraph",
          text: "What is it? A blockchain that allows developers to create decentralized applications, known as dApps, and smart contracts.",
        },
        {
          type: "paragraph",
          text: "Main use: Decentralized finance, NFTs, DAOs, and much more.",
        },
        {
          type: "paragraph",
          text: "Extra fact: In 2022, it switched to a more eco-friendly system called Proof of Stake.",
        },
        {
          type: "table",
          headers: [
            "Concept",
            "What is it?",
            "What is it used for?",
            "Real example",
          ],
          rows: [
            [
              "DeFi",
              "Finance without banks",
              "Lending, saving, investing crypto",
              "An app that pays you interest",
            ],
            [
              "NFT",
              "A unique digital object",
              "Art, music, tickets, collectibles",
              "Exclusive NFT album",
            ],
            [
              "DAO",
              "A digital community without bosses",
              "Voting, organizing, investing as a group",
              "An art fund managed by voting",
            ],
          ],
        },
      ],
    },
    {
      id: "solana",
      navLabel: "Solana (SOL)",
      title: "🔹 Solana (SOL): speed for games and NFTs",
      content: [
        {
          type: "paragraph",
          text: "What is it? A blockchain focused on speed and very low fees.",
        },
        {
          type: "paragraph",
          text: "Main use: Web3 games, NFT marketplaces, mobile apps.",
        },
        {
          type: "paragraph",
          text: "Extra fact: It has experienced technical outages, but its community continues to grow.",
        },
      ],
    },
    {
      id: "cardano",
      navLabel: "Cardano (ADA)",
      title: "🔹 Cardano (ADA): sustainability and inclusion",
      content: [
        {
          type: "paragraph",
          text: "What is it? A blockchain based on academic research and scientific peer review.",
        },
        {
          type: "paragraph",
          text: "Main use: Social projects, digital voting, and smart contracts.",
        },
        {
          type: "paragraph",
          text: "Extra fact: It works with African governments to register educational data.",
        },
      ],
    },
    {
      id: "polygon",
      navLabel: "Polygon (MATIC)",
      title: "🔹 Polygon (MATIC): accelerating Ethereum",
      content: [
        {
          type: "paragraph",
          text: "What is it? A solution connected to Ethereum that makes it faster and cheaper.",
        },
        {
          type: "paragraph",
          text: "Main use: Developing apps, loyalty programs, digital collectibles.",
        },
        {
          type: "paragraph",
          text: "Extra fact: It has been used by major brands such as Disney, Meta, Adidas, and Reddit.",
        },
      ],
    },
    {
      id: "stellar",
      navLabel: "Stellar (XLM)",
      title: "🔹 Stellar (XLM): fast and simple international payments",
      content: [
        {
          type: "paragraph",
          text: "What is it? A blockchain designed for fast global transfers with low costs.",
        },
        {
          type: "paragraph",
          text: "Main use: Sending money between countries, converting local currencies, working with NGOs.",
        },
        {
          type: "paragraph",
          text: "Extra fact: It has partnerships with Visa, IBM, MoneyGram, and the UN.",
        },
      ],
    },
    {
      id: "videos",
      navLabel: "Videos",
      title: "📺 Recommended videos",
      content: [
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=dsTDTa1aP7M",
          text: "🎥 What is Bitcoin and how does it work?",
        },
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=36t2S6NeUgU",
          text: "🎥 What is Ethereum?",
        },
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=HzF6kyS3Fb8",
          text: "🎥 Solana vs Ethereum: Which is better?",
        },
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=ACD2qlb76OgM",
          text: "🎥 What is Cardano?",
        },
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=AfyudjDyp3U",
          text: "🎥 Polygon explained simply",
        },
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=ectLrWsYGgs",
          text: "🎥 What is Stellar (XLM)?",
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Activity",
      title: "📊 Module activity",
      content: [
        "Complete a comparison table between the 6 networks studied. You can use Google Docs, Canva, Notion, or paper.",
        {
          type: "table",
          headers: [
            "Network",
            "What is it used for?",
            "Approx. speed (TPS)",
            "Security",
            "Community / Featured projects",
          ],
          rows: [
            ["Bitcoin", "", "", "", ""],
            ["Ethereum", "", "", "", ""],
            ["Solana", "", "", "", ""],
            ["Cardano", "", "", "", ""],
            ["Polygon", "", "", "", ""],
            ["Stellar", "", "", "", ""],
          ],
        },
      ],
    },
    {
      id: "nota",
      navLabel: "Important note",
      title:
        "⚠️ IMPORTANT NOTE – Do not confuse the network, token, abbreviation, and cryptocurrency",
      content: [
        {
          type: "paragraph",
          text: "In the crypto world, there are terms that sound similar but do not mean the same thing. Understanding them can prevent you from losing money by mistake.",
        },
        {
          type: "paragraph",
          text: "🧩 What is the difference?",
        },
        {
          type: "table",
          headers: ["Term", "What is it?", "Example"],
          rows: [
            [
              "Cryptocurrency",
              "The digital asset itself. Like a virtual currency with value.",
              "USDC, BTC, ETH",
            ],
            [
              "Token",
              "A type of cryptocurrency created on an existing blockchain.",
              "USDC is a token on Ethereum, Polygon, Solana...",
            ],
            [
              "Network (blockchain)",
              "The infrastructure where crypto assets live. Each network has its own rules.",
              "Ethereum, Solana, Stellar",
            ],
            [
              "Abbreviation",
              "The letters that represent a crypto asset on platforms.",
              "BTC = Bitcoin, ETH = Ethereum, XLM = Stellar",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "🔄 The same token can exist on several networks",
        },
        {
          type: "paragraph",
          text: "For example, USDC exists on Ethereum, Polygon, Solana, and Stellar. But technically, it is NOT the same USDC on each network. If you send USDC through the wrong network, the receiver may get nothing.",
        },
        {
          type: "paragraph",
          text: "⚠️ What happens if you choose the wrong network?",
        },
        {
          type: "list",
          items: [
            "You could lose your funds forever",
            "It is not always possible to “reverse” a crypto transfer",
          ],
        },
        {
          type: "paragraph",
          text: "That is why, before sending, you must verify everything:",
        },
        {
          type: "orderedList",
          items: [
            "The correct network (Ethereum, Solana, etc.)",
            "The recipient address (it must be compatible with the network and token)",
            "The correct token (for example, USDT on Polygon ≠ USDT on Ethereum)",
          ],
        },
        {
          type: "paragraph",
          text: "🧠 In Web3, there is no “cancel” button and no customer service team that can recover funds lost by mistake. You are the custodian.",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Quote of the day",
      title: "🧠 Quote of the day",
      content: [
        "It is not about which blockchain is better, but which one solves a real problem better.",
      ],
    },
  ],
};

export default modulo3;
